export default __webpack_public_path__ + "static/media/Thông-bao_UBND-xã-Vinh-Kim.6be1c713.pdf";